export default __webpack_public_path__ + "static/media/news (4).9d8c7791.jpg";